import { AvailableExtra, ExtraSlug } from '@/types/types';

export interface InsurancesInfoResponse {
    [key: number]: InsuranceInfo;
}

export interface InsuranceInfo {
    extraId: number;
    priceListParamsValues1: PriceListParamsValues;
    priceListParamsValues2: PriceListParamsValues;
    retailPriceAmount: number | number;
    isFlatRate: boolean;
    priceListParamsValues3: null;
    paxRetailPrice: number | number;
    coverageExtensions: CoverageExtension[];
    priceListId: number;
    isPaymentLetter: boolean;
    policyId: number;
    basePrices: BasePrices;
    netPremiumAmount: number;
    policy: Policy;
    insurancePrice: number;
}

export interface BasePrices {
    noAgeRate: number;
    idDyn: number;
    deleteDate: null;
}

export interface CoverageExtension {
    coverage: Coverage;
    priceListCoverages: PriceListCoverages;
    extensionType: string;
    coverageExtensionsValues: CoverageExtensionsValue[];
}

export interface Coverage {
    observations: null | string;
    webName: string;
    idDyn: number;
    name: string;
    isGroup: number;
}

export interface CoverageExtensionsValue {
    priceListCoveragesDesc: PriceListCoveragesDesc | null;
    priceListCoveragesValues: PriceListCoverages | null;
    retailPremiumAmount: number;
    extensionLimit: number;
    isIncluded: boolean;
}

export interface PriceListCoveragesDesc {
    idDyn: number;
}

export interface PriceListCoverages {
    idDyn: number;
    deleteDate: null;
}

export interface Policy {
    product: Product;
    idDyn: number;
    policyNumber: string;
    policyBranch: string;
}

export interface Product {
    idDyn: number;
    productName: string;
}

export interface PriceListParamsValues {
    idDyn: number;
    name: string;
    maxRange: number;
    priceListParamsValuesCountry: any[];
    minRange: number;
    priceListParamsValuesTranslationsId: number;
    deleteDate: null;
}

export const adaptInsurances = (insurancesInfo: InsurancesInfoResponse): AvailableExtra[] => {
    const insurancesArray = Object.values(insurancesInfo) as InsuranceInfo[];

    const adaptedInsurances = insurancesArray.map((insurance) => {
        const slug = insurance.extraId === 33 ? ExtraSlug.travelCancelInsurance : ExtraSlug.travelCancelInsurancePlus;

        return {
            id: insurance.extraId,
            type: '',
            slug,
            name: insurance?.policy?.product?.productName ?? '',
            price_type: '',
            price: `${insurance.insurancePrice}`,
            extra_day_price: '',
            percentage: '',
            required: false,
            min_value: null,
            max_value: null,
            steps: null,
            file: null,
            options: null,
            data: insurance,
        };
    });

    return adaptedInsurances;
};
